/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import SellerActions from '@Actions/sellerActions';
import AddressActions from '@Actions/addressActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';
import { Select } from 'antd';
import { GetTallyConfigurations } from '../../../modules/getTallyConfigurations';
import PRZSelect from '../UI/PRZSelect';

/**
 *
 */
class UpdateAddressForm extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {*&{district: *, state: *}}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.selectedAddress?.address_id && !state.userReady) {
      return {
        address: props.selectedAddress?.address1,
        district: props.selectedAddress?.city,
        state: props.selectedAddress?.state,
        pinCode: props.selectedAddress?.postal_code,
        tallyAddressType: props.selectedAddress?.tally_address_type,
        ...state,

      };
    }
    if (props.pincodeCity) {
      const city = props.pincodeCity;
      const cityState = props.pincodeState;
      props.setCityState(null, null);
      return {
        ...state, district: city, state: cityState,
      };
    }
    return state;
  }

  /**
   *
   */
  componentDidMount() {
    const { getTallyConfigurations, user } = this.props;

    if (this.isTallyConnected()) {
      getTallyConfigurations({
        query: {
          org_id: user?.org_id,
          column_type: 'ADDRESS',
        },
      }, () => {});
    }
  }

  isTallyConnected = () => {
    const { user, tenantId } = this.props;

    const orgId = user?.org_id;

    const tallyTenant = user?.user_tenants?.find((item) => (item?.org_id === orgId && item?.tenant_id === tenantId));

    return !!tallyTenant?.it_id;
  }

  /**
   *
   */
          addAddress = () => {
            this.setState({ formSubmitted: true });
            const {
              address, district, state, pinCode, tallyAddressType,
            } = this.state;
            const {
              seller, updateAddress, addressType, selectedTenantId, selectedAddress, entityType, entityId,
            } = this.props;
            const { callback, user } = this.props;

            if (address && district && state && pinCode) {
              const payload = {
                address_id: selectedAddress?.address_id,
                address1: address,
                address2: '',
                address3: '',
                city: district,
                state,
                country: 'India',
                postal_code: pinCode,
                entity_type: entityType,
                entity_id: entityId,
                tally_address_type: tallyAddressType,
              };
              updateAddress(payload, (addressResponse) => callback(addressResponse));
            }
          }

          /**
           *
           * @return {JSX.Element}
           */
          render() {
            const {
              updateAddressLoading, getCityState, tallyConfigurations, tallyConfigurationsLoading,
            } = this.props;
            const {
              formSubmitted,
              address, district, state, pinCode, tallyAddressType,
            } = this.state;
            return (
              <div className="ant-row">
                <div className="ant-col-md-24 ant-col-xs-24">
                  <div className="orgInputContainer">
                    <H3FormInput
                      isTextarea
                      name="address"
                      type="text"
                      containerClassName="orgInputContainer"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput address-text-area"
                      placeholder=""
                      onChange={(event) => this.setState({ address: event.target.value })}
                      value={address}
                      label="Street"
                      disabled={updateAddressLoading}
                      showError={formSubmitted && !address}
                      required
                    />
                  </div>
                </div>
                <div className="ant-col-md-8">
                  <H3FormInput
                    name="a valid pincode"
                    type="number"
                    containerClassName="orgInputContainer address__right-input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    placeholder=""
                    onChange={(event) => (event.target.value.length <= 6 ? this.setState({ pinCode: event.target.value }) : '')}
                    onBlur={(event) => (event.target.value.length <= 6 ? getCityState(event.target.value) : '')}
                    value={pinCode}
                    label="Pin Code"
                    required
                    disabled={updateAddressLoading}
                    showError={formSubmitted && !pinCode}
                  />
                </div>
                <div className="ant-col-md-8">
                  <H3FormInput
                    name="district"
                    type="text"
                    containerClassName="orgInputContainer address__mid-input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    placeholder=""
                    onChange={(event) => this.setState({ district: event.target.value })}
                    value={district}
                    label="District"
                    showError={formSubmitted && !district}
                    required
                  />
                </div>
                <div className="ant-col-md-8">
                  <H3FormInput
                    name="state"
                    type="text"
                    containerClassName="orgInputContainer address__left-input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    placeholder=""
                    onChange={(event) => this.setState({ state: event.target.value })}
                    value={state}
                    label="State"
                    showError={formSubmitted && !state}
                    required
                  />
                </div>
                {this.isTallyConnected() && (
                  <div className="ant-col-md-24 ant-col-xs-24">
                    <label className="orgFormLabel"> Tally Address Type</label>
                    <PRZSelect
                      value={tallyAddressType}
                      disabled={updateAddressLoading || tallyConfigurationsLoading}
                      style={{
                        marginTop: '1px',
                        marginBottom: '12px',
                      }}
                      onChange={(value) => {
                        this.setState({
                          tallyAddressType: value,
                        });
                      }}
                    >
                      {tallyConfigurations?.tally_address_types?.map((item) => (
                        <Option key={item?.address_type}>
                          {item?.address_type}
                        </Option>
                      ))}
                    </PRZSelect>
                  </div>
                )}
                <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
                  <H3Button
                    buttonType={defaultButtonTypes.BLUE_ROUNDED}
                    text="Update New Address"
                    onClick={() => this.addAddress()}
                    isLoading={updateAddressLoading}
                    disabled={updateAddressLoading}
                    style={{
                      width: '200px',
                      borderRadius: '5px',
                      padding: '7px 0px',
                      marginLeft: '0',
                    }}
                  />
                </div>
              </div>

            );
          }
}

const mapStateToProps = ({
  SellerReducers, ProductReducers, TenantReducers, AddressReducer, GetTallyConfigurations, UserReducers,
}) => ({
  cityStateLoading: SellerReducers.cityStateLoading,
  pincodeCity: SellerReducers.pincodeCity,
  pincodeState: SellerReducers.pincodeState,
  setCityStateError: SellerReducers.setCityStateError,
  createSellerLoading: SellerReducers.createSellerLoading,
  addProductToInventoryLoading: ProductReducers.addProductToInventoryLoading,
  tenants: TenantReducers.tenants,
  products: ProductReducers.products,
  updateAddressLoading: AddressReducer.updateAddressLoading,
  tallyConfigurations: GetTallyConfigurations.data,
  tallyConfigurationsLoading: GetTallyConfigurations.loading,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  setCityState: (city, state) => dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  updateAddress: (payload, callback) => dispatch(AddressActions.updateAddress(payload, callback)),
  getTallyConfigurations: (payload, callback) => dispatch(GetTallyConfigurations.actions.request(payload, callback)),
});

UpdateAddressForm.propTypes = {
  pincodeCity: PropTypes.string,
  pincodeState: PropTypes.string,
  setCityState: PropTypes.func,
  user: PropTypes.any,
  callback: PropTypes.any,
  updateAddressLoading: PropTypes.bool,
  seller: PropTypes.any,
  selectedTenantId: PropTypes.any,
  selectedAddress: PropTypes.any,
  getCityState: PropTypes.func,
  updateAddress: PropTypes.func,
  addressType: PropTypes.any,
  entityType: PropTypes.any,
  entityId: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdateAddressForm));
